import React, { useEffect, useState } from "react";
import Footer from "../../CoreComponents/Footer";
import Header from "../../CoreComponents/Header";
import MainHeader from "../../CoreComponents/MainHeader";
import NavBar from "../../CoreComponents/NavBar";
import { ManageOrderReportsNew } from "./logic";
import {
  showMessage,
  ManageRestaurant,
  diffArray,
  ManageDeliveryBoy,
  excludeArrayFromArray,
} from "../../Functionalities/Functions";
import {
  ONLINE_PAYMENT_AMOUNT,
  DELIVERY_CHARGE_WAIVED,
  deliveryChargeDisplay,
  columnLabel,
  migrateLegacyColumns,
  footerCell,
  isPercentageColumn,
  reportExList,
  withDerivedColumns,
  withoutHiddenColumns,
} from "../../Functionalities/reportColumns";
import FilterComponent from "../../CoreComponents/FilterComponent";
import FilterModalComponent from "../../CoreComponents/FilterModalComponent";
import {
  is_franchise_accountant,
  is_superuser,
  sees_all_franchises,
  works_in_franchise,
  picked_franchise_id,
  is_shop_manager,
  is_shop_admin,
} from "../../Functionalities/Config";
import NoDataComponent from "../../CoreComponents/NoDataComponent";
import LoadingComponent from "../../CoreComponents/LoadingComponent";
import ColumnModalComponent from "../../CoreComponents/ColumnModalComponent";
import ReportStatusModalComponent from "../../CoreComponents/ReportStatusModalComponent";
import { ManageFranchise } from "../Franchise/Logic";

import DayBasisSwitch from "../../CoreComponents/DayBasisSwitch";
import { DAY_PLACED, basisParam, useRefetchOnBasis } from "../../Functionalities/dayBasis";

function Body() {
  const [basis, setBasis] = useState(DAY_PLACED);
  const [data, setData] = useState({ id: "", name: "", data: [] });
  const [loading, setLoading] = useState(false);
  const [active, setActive] = useState(false);

  const defaultColums = [
    "id",
    "order_type",
    "order_status",
    "promocode_type",
    "amount",
    "extra_commission_perc",
    "extra_commission_rate",
    "amount_wo_extra_commission",
    "franchise_charge",
    "restaurent_charge",
    "branch_gst_charge",
    "branch_gst_perc",
    "delivery_charge",
    DELIVERY_CHARGE_WAIVED,
    "wallet_amount_used",
    "offer_discount",
    "promocode_discount",
    "total_food_amount",
    "grand_total",
    "franchise_collected_amount",
    ONLINE_PAYMENT_AMOUNT,
    "commission_on_restaurent",
    "commission_amount_on_restaurent",
    "refund_amount",
    "amount_to_restaurant",
    "delivery_boy_tip",
    "foodoor_cares",
    "delivery_boy_earn",
    "created_time",
    "updated_time",
    "franchise",
    "branch",
    "user_of_intrest",
    "order",
    "delivery_boy",
    // "payment_mode",
    "to_franchise_tstatus",
    "to_admin_tstatus",
    "to_branch_tstatus",
  ];

  // JSON.parse
  const [columns, setColumns] = useState(
    localStorage.getItem("foodoor_table_heading_order")
      ? withoutHiddenColumns(
          migrateLegacyColumns(
            JSON.parse(localStorage.getItem("foodoor_table_heading_order"))
          )
        )
      : defaultColums
  );

  const [selectedColumns, setSelectedColumns] = useState(
    localStorage.getItem("foodoor_report_cache")
      ? migrateLegacyColumns(JSON.parse(localStorage.getItem("foodoor_report_cache")))
      : []
  );
  // const [selectedColumns, setSelectedColumns] = useState(
  //   localStorage.getItem('foodoor_report_cache') ? JSON.parse(localStorage.getItem('foodoor_report_cache')) : []
  // )

  const [filter, setfilter] = useState({
    franchise_id: picked_franchise_id,
    branch_id: "",
    deliveryboy_id: "",
    order_id: "FDR",
    from_date: new Date().toISOString().slice(0, 10) + " 00:00:00",
    to_date: new Date().toISOString().slice(0, 10) + " 00:00:00",
    search_text: "",
    payment_transaction_status: "",
    status: ["COMPLETED"],
    keyword: is_shop_admin || is_shop_manager ? "to_branch" : "",
    id: "",
    //"transaction_type": "", // [ ORDER_TRANSACTION, FRANCHISE_TRANSACTION, BRANCH_TRANSACTION] ,
    //"mode_of_payment": "", // [ORDER,CASH,ONLINE]
    order_type: "", // [COD, ONLINE, WALLET, SUBSCRIPTION]
    order_status: null, // ['COMPLETED', 'CUSTOMER_CANCELLED', 'DECLINED_ORDER', 'CUSTOMER_DROPED', 'DELIVERY_BOY_DROPED', 'RESTAURANT_DROPED']
    promocode_type: null, // ['ADMIN', 'FRANCHISE']
    in_profit: null, // ['LOSS', 'PROFIT', 'NEUTRAL' ]
    amount: 0,
    extra_commission_perc: 0,
    extra_commission_rate: 0,
    amount_wo_extra_commission: 0,
    franchise_charge: 0,
    restaurent_charge: 0,
    branch_gst_charge: 0,
    branch_gst_perc: 0,
    delivery_charge: 0,
    wallet_amount_used: 0,
    offer_discount: 0,
    promocode_discount: 0,
    total_food_amount: 0,
    grand_total: 0,
    franchise_collected_amount: 0,
    commission_on_restaurent: 0,
    commission_amount_on_restaurent: 0,
    commission_on_franchise: 0,
    commission_amount_on_franchise: 0,
    refund_amount: 0,
    amount_to_restaurant: 0,
    // "incentive": 0,
    delivery_boy_tip: 0,
    foodoor_cares: 0,
    delivery_boy_earn: 0,
    franchise_net_balance: 0,
    // "amount_credited": 0,
    // "amount_debited": 0,
    created_time: "",
    updated_time: "",

    franchise: 1,
    branch: 3,
    user_of_intrest: 12, // who initiated
    order: 3,
    delivery_boy: null,
  });

  const [restrarent, setrestrarent] = useState({ id: "", name: "", data: [] });
  const [franchise, setfranchise] = useState({ id: "", name: "", data: [] });
  const [deliveryBoy, setDeliveryBoy] = useState({
    id: "",
    name: "",
    data: [],
  });

  useEffect(() => {
    fetchData();
    (works_in_franchise || is_franchise_accountant) &&
      getBranches();
    (works_in_franchise || is_franchise_accountant) &&
      getDeliveryBoys();
    sees_all_franchises && getFranchise();
  }, []);

  useEffect(() => {}, []);
  function Pop(name) {
    const new_arr = selectedColumns.filter((item) => item !== name);
    setSelectedColumns(new_arr);
  }

  const Push = (name) => {
    setSelectedColumns((prev) => [...prev, name]);
  };

  const clearSelectedColumns = () => {
    fetchData();

    setSelectedColumns([]);
    localStorage.setItem("foodoor_report_cache", JSON.stringify([]));
  };

  const applySelectedColumns = () => {
    fetchData();
    localStorage.setItem(
      "foodoor_report_cache",
      JSON.stringify(selectedColumns)
    );
  };

  const resetColums = () => {
    setColumns(defaultColums);
    localStorage.setItem(
      "foodoor_table_heading_order",
      JSON.stringify(defaultColums)
    );
  };

  //keyword : to_admin, to_franchise, to_branch
  //payment_mode : CASH,ONLINE
  // let params = `delivery_boy_id=${filter.deliveryboy_id}&payment_transaction_status=${'PENDING'}&keyword=${"to_admin"}& payment_mode=${"CASH"}&franchise_id=${filter.franchise_id}&branch_id=${filter.branch_id}&from_date=${filter.from_date}&to_date=${filter.to_date}`
  let params = `order_status_lst=${JSON.stringify(
    filter.status
  )}&delivery_boy_id=${filter.deliveryboy_id}&payment_transaction_status=${
    filter.payment_transaction_status
  }&keyword=${filter.keyword}& payment_mode=${"CASH"}&franchise_id=${
    filter.franchise_id
  }&branch_id=${filter.branch_id}&from_date=${filter.from_date}&to_date=${
    filter.to_date
  }&page_wise=0${basisParam(basis)}`;

  useRefetchOnBasis(basis, () => fetchData());

  const ex_list_param = () => {
    let newselectedColumns = reportExList(selectedColumns);
    let param_exlist = "&ex_list=" + JSON.stringify(newselectedColumns);
    return param_exlist;
  };

  const fetchData = () => {
    setLoading(true);
    let result = ManageOrderReportsNew("", "", "get", params + ex_list_param());
    result.then((result) => {
      if (result) {
        setData({ ...data, data: withDerivedColumns(result.data) });
        setLoading(false);
      } else {
        setLoading(false);
      }
    });
  };

  const getBranches = () => {
    showMessage(
      "Loading Restaurant",
      "info",
      "Loading",
      "bottom",
      "bottom-left",
      0
    );
    let params = "page_wise=false&for_dropdown=1&order_by_name=true";
    let result = ManageRestaurant("", "", "get", params);
    result
      .then((result) => {
        setrestrarent({
          ...restrarent,
          data: result?.data,
        });
      })
      .catch((err) => {
        showMessage(
          JSON.stringify(err),
          "danger",
          "Loading error",
          "top",
          "top-center",
          0
        );
      });
  };

  const getFranchise = () => {
    showMessage(
      "Loading Franchise",
      "info",
      "Loading",
      "bottom",
      "bottom-left",
      0
    );
    let params = "page_wise=false&for_dropdown=1";
    let result = ManageFranchise("", "", "get", params);
    result
      .then((result) => {
        setfranchise({
          ...franchise,
          data: result.data,
        });
      })
      .catch((err) => {
        showMessage(
          JSON.stringify(err),
          "danger",
          "Loading error",
          "top",
          "top-center",
          0
        );
      });
  };
  const getDeliveryBoys = () => {
    showMessage(
      "Loading Delivery boys",
      "info",
      "Loading",
      "bottom",
      "bottom-left",
      0
    );
    let params = "for_dropdown=1&page_wise=false&order_by_name=true";
    let result = ManageDeliveryBoy("", "get", "", params);
    result
      .then((result) => {
        if (result) {
          setDeliveryBoy({
            ...deliveryBoy,
            data: result.data,
          });
        }
      })
      .catch((err) => {
        showMessage(
          "Error loading delivery boys",
          "danger",
          "Loading error",
          "top",
          "top-right",
          0
        );
      });
  };

  const [checkedRows, setCheckedRows] = useState([]);
  const [checkboxAll, setcheckboxAll] = useState(false);

  const checkAllRow = () => {
    let checked = [];
    data.data.map((item, index) => {
      checked.push(item.id);
    });
    setCheckedRows(checked);
    setcheckboxAll(true);
  };
  const uncheckAllRow = async () => {
    await setCheckedRows([]);
    setcheckboxAll(false);
  };

  const checkSingleRow = (id) => {
    setCheckedRows((prev) => [...prev, id]);
  };
  const uncheckSingleRow = (id) => {
    const new_arr = checkedRows.filter((item) => item !== id);
    setCheckedRows(new_arr);
  };

  const containsItem = (id) => {
    let flag = true;
    flag = checkedRows.includes(id) ? (flag = true) : (flag = false);

    return flag;
  };

  const confirmStatus = (statusData) => {
    let result = ManageOrderReportsNew(
      "",
      {
        transaction_list: JSON.stringify(checkedRows),
        keyword: statusData.keyword,
        status: statusData.status,
      },
      "add",
      ""
    );
    result
      .then((res) => {
        if (res) {
          if (res.data.Status === true) {
            showMessage(
              "Section added",
              "success",
              "Success!",
              "top",
              "top-right",
              0
            );
            uncheckAllRow();
            fetchData();
          } else {
            showMessage(
              res.data.Error,
              "danger",
              "Failed!",
              "top",
              "top-right",
              0
            );
          }
        } else {
        }
      })
      .catch((err) => {
        showMessage(
          JSON.stringify(err),
          "danger",
          "Loading error",
          "top",
          "top-center",
          0
        );
      });
  };

  const setActiveRow = (id) => {
    if (active === true) {
      setActive(false);
    } else {
      setActive(true);
    }
  };

  return (
    <div class="content-body">
      {!loading ? (
        <div class="container-fluid">
          <div className="mb-3">
            <DayBasisSwitch value={basis} onChange={setBasis} />
          </div>
          <FilterModalComponent
            heading={"Filter Order Reports"}
            fromDateValue={filter.from_date.slice(0, 10)}
            fromDateChange={(e) => {
              setfilter({ ...filter, from_date: e.target.value + " 00:00:00" });
            }}
            toDateValue={filter.to_date.slice(0, 10)}
            toDateChange={(e) => {
              setfilter({ ...filter, to_date: e.target.value + " 00:00:00" });
            }}
            clearFilter={(e) => {
              e.preventDefault();
              window.location.reload();
            }}
            submitFilter={(e) => {
              e.preventDefault();
              if (filter.from_date) {
                if (!filter.to_date) {
                  showMessage(
                    "From and To dates are mandatory",
                    "danger",
                    "Error!",
                    "top",
                    "top-right",
                    0
                  );
                  return;
                }
              }
              if (filter.to_date) {
                if (!filter.from_date) {
                  showMessage(
                    "From and To dates are mandatory",
                    "danger",
                    "Error!",
                    "top",
                    "top-right",
                    0
                  );
                  return;
                }
              }
              fetchData();
            }}
          >
            <div className="col-lg-12">
              <label className="text-black font-w600">
                Order status <span className="required"></span>
              </label>
            </div>
            <div className="col-lg-6">
              <input
                id="COMPLETED"
                type="checkbox"
                label="ok"
                checked={filter.status.some((item) => item == "COMPLETED")}
                onChange={(e) => {
                  if (filter.status.some((item) => item == "COMPLETED")) {
                    setfilter({
                      ...filter,
                      status: filter.status.filter(
                        (item) => item != "COMPLETED"
                      ),
                    });
                  } else {
                    setfilter({
                      ...filter,
                      status: [...filter.status, "COMPLETED"],
                    });
                  }
                }}
              />
              <label className="ml-2" for="COMPLETED">
                COMPLETED
              </label>
              <br></br>
            </div>
            <div className="col-lg-6">
              <input
                id="CUSTOMER_CANCELLED"
                type="checkbox"
                label="ok"
                checked={filter.status.some(
                  (item) => item == "CUSTOMER_CANCELLED"
                )}
                onChange={(e) => {
                  if (
                    filter.status.some((item) => item == "CUSTOMER_CANCELLED")
                  ) {
                    setfilter({
                      ...filter,
                      status: filter.status.filter(
                        (item) => item != "CUSTOMER_CANCELLED"
                      ),
                    });
                  } else {
                    setfilter({
                      ...filter,
                      status: [...filter.status, "CUSTOMER_CANCELLED"],
                    });
                  }
                }}
              />
              <label className="ml-2" for="CUSTOMER_CANCELLED">
                CUSTOMER CANCELLED
              </label>
              <br></br>
            </div>
            <div className="col-lg-6">
              <input
                id="DECLINED_ORDER"
                type="checkbox"
                label="ok"
                checked={filter.status.some((item) => item == "DECLINED_ORDER")}
                onChange={(e) => {
                  if (filter.status.some((item) => item == "DECLINED_ORDER")) {
                    setfilter({
                      ...filter,
                      status: filter.status.filter(
                        (item) => item != "DECLINED_ORDER"
                      ),
                    });
                  } else {
                    setfilter({
                      ...filter,
                      status: [...filter.status, "DECLINED_ORDER"],
                    });
                  }
                }}
              />
              <label className="ml-2" for="DECLINED_ORDER">
                DECLINED ORDER
              </label>
              <br></br>
            </div>
            <div className="col-lg-6">
              <input
                id="CUSTOMER_DROPED"
                type="checkbox"
                label="ok"
                checked={filter.status.some(
                  (item) => item == "CUSTOMER_DROPED"
                )}
                onChange={(e) => {
                  if (filter.status.some((item) => item == "CUSTOMER_DROPED")) {
                    setfilter({
                      ...filter,
                      status: filter.status.filter(
                        (item) => item != "CUSTOMER_DROPED"
                      ),
                    });
                  } else {
                    setfilter({
                      ...filter,
                      status: [...filter.status, "CUSTOMER_DROPED"],
                    });
                  }
                }}
              />
              <label className="ml-2" for="CUSTOMER_DROPED">
                CUSTOMER DROPPED
              </label>
              <br></br>
            </div>
            <div className="col-lg-6">
              <input
                id="DELIVERY_BOY_DROPED"
                type="checkbox"
                label="ok"
                checked={filter.status.some(
                  (item) => item == "DELIVERY_BOY_DROPED"
                )}
                onChange={(e) => {
                  if (
                    filter.status.some((item) => item == "DELIVERY_BOY_DROPED")
                  ) {
                    setfilter({
                      ...filter,
                      status: filter.status.filter(
                        (item) => item != "DELIVERY_BOY_DROPED"
                      ),
                    });
                  } else {
                    setfilter({
                      ...filter,
                      status: [...filter.status, "DELIVERY_BOY_DROPED"],
                    });
                  }
                }}
              />
              <label className="ml-2" for="DELIVERY_BOY_DROPED">
                DELIVERY BOY DROPPED
              </label>
              <br></br>
            </div>
            <div className="col-lg-6 mb-3">
              <input
                id="RESTAURANT_DROPED"
                type="checkbox"
                label="ok"
                checked={filter.status.some(
                  (item) => item == "RESTAURANT_DROPED"
                )}
                onChange={(e) => {
                  if (
                    filter.status.some((item) => item == "RESTAURANT_DROPED")
                  ) {
                    setfilter({
                      ...filter,
                      status: filter.status.filter(
                        (item) => item != "RESTAURANT_DROPED"
                      ),
                    });
                  } else {
                    setfilter({
                      ...filter,
                      status: [...filter.status, "RESTAURANT_DROPED"],
                    });
                  }
                }}
              />
              <label className="ml-2" for="RESTAURANT_DROPED">
                RESTAURANT DROPPED
              </label>
              <br></br>
            </div>

            {(is_superuser ||
              works_in_franchise ||
              is_franchise_accountant) && (
              <div className="col-lg-6">
                <div className="form-group">
                  <label className="text-black font-w600">
                    {sees_all_franchises ? "Franchise" : "Restaurant"}{" "}
                    <span className="required"></span>
                  </label>
                  <select
                    value={
                      sees_all_franchises ? filter.franchise_id : filter.branch_id
                    }
                    className="form-control form-control-lg"
                    onChange={(e) =>
                      sees_all_franchises
                        ? setfilter({ ...filter, franchise_id: e.target.value })
                        : setfilter({ ...filter, branch_id: e.target.value })
                    }
                  >
                    <option value={""} id={""}>
                      All
                    </option>
                    {(sees_all_franchises ? franchise : restrarent).data.map(
                      (item) => (
                        <option value={item.id} id={item.id}>
                          {item.name}
                        </option>
                      )
                    )}
                  </select>
                </div>
              </div>
            )}
            {(works_in_franchise ||
              is_franchise_accountant) && (
              <div className="col-lg-6">
                <div className="form-group">
                  <label className="text-black font-w600">
                    Delivery Boy <span className="required"></span>
                  </label>
                  <select
                    value={filter.deliveryboy_id}
                    className="form-control form-control-lg"
                    onChange={(e) =>
                      setfilter({ ...filter, deliveryboy_id: e.target.value })
                    }
                  >
                    <option value={""} id={""}>
                      All
                    </option>
                    {deliveryBoy.data.map((item) => (
                      <option value={item.id} id={item.id}>
                        {item.first_name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            )}

            <div className="col-lg-6">
              <div className="form-group">
                <label className="text-black font-w600">
                  Payment transaction status <span className="required"></span>
                </label>
                <select
                  value={filter.payment_transaction_status}
                  className="form-control form-control-lg"
                  onChange={(e) =>
                    setfilter({
                      ...filter,
                      payment_transaction_status: e.target.value,
                    })
                  }
                >
                  <option value="">All</option>
                  <option value="PENDING">PENDING</option>
                  <option value="PROCESSING">PROCESSING</option>
                  <option value="COMPLETED">COMPLETED</option>
                  <option value="DECLINED">DECLINED</option>
                </select>
              </div>
            </div>

            {
              <div className="col-lg-6">
                <div className="form-group">
                  <label className="text-black font-w600">
                    To whom <span className="required"></span>
                  </label>
                  <select
                    disabled={is_shop_manager || is_shop_admin}
                    value={filter.keyword}
                    className="form-control form-control-lg"
                    onChange={(e) =>
                      setfilter({ ...filter, keyword: e.target.value })
                    }
                  >
                    <option value="">All</option>
                    <option value="to_admin">To admin</option>
                    <option value="to_franchise">To franchise</option>
                    <option value="to_branch">To branch</option>
                  </select>
                </div>
              </div>
            }
          </FilterModalComponent>

          <ColumnModalComponent
            Push={Push}
            Pop={Pop}
            selectedColumns={excludeArrayFromArray(
              ["alreay managed in the fucntion"],
              selectedColumns
            )}
            columns={excludeArrayFromArray(
              ["alreay managed in the fucntion"],
              columns
            )}
            heading="Select Columns"
            applySelectedColumns={applySelectedColumns}
            clearSelectedColumns={clearSelectedColumns}
            setOrder={(neworder) => setColumns(neworder)}
            reset={resetColums}
          />

          <ReportStatusModalComponent
            heading="Change Payment Status"
            confirmStatus={confirmStatus}
          />
          {void 0}
          <FilterComponent
            filterButtonName={"Filter"}
            columnButtonName={"columns"}
            changeStatusBtnname={"Change status"}
            export={{
              data: data.data,
              columns: diffArray(
                columns,
                excludeArrayFromArray(["managed in funciton"], selectedColumns)
              ),
              defaultColums: defaultColums,
            }} // export to excel
            type="Order"
          />
          {data.data.length > 0 ? (
            <>
              <div className="row">
                <div className="col-lg-12">
                  <div
                    className="table-responsive rounded card-table"
                    style={{ height: "calc(100vh - 18rem)", minHeight: "35rem" }}
                  >
                    <div
                      id="example5_wrapper"
                      class="dataTables_wrapper no-footer"
                    >
                      <table
                        className="table border-no  table-hover xorder-table mb-0 table-responsive-lg xdataTablesCard"
                        id="example5"
                      >
                        <thead
                          style={{
                            boxShadow: "1px 1px 4px 1px #929292",
                            position: "sticky",
                            top: "0",
                            backgroundColor: "rgb(224, 224, 224)",
                          }}
                        >
                          <tr>
                            {diffArray(columns, selectedColumns).map(
                              (item, index) => {
                                return (
                                  <th
                                    style={{ textTransform: "capitalize" }}
                                    title={item}
                                  >
                                    {item === "id" && (
                                      <input
                                        type="checkbox"
                                        className="mr-3"
                                        checked={checkboxAll}
                                        onChange={(e) =>
                                          e.target.checked
                                            ? checkAllRow()
                                            : uncheckAllRow()
                                        }
                                      />
                                    )}
                                    {`${columnLabel(item)} ${
                                      item === "id" ? data?.data?.length : ""
                                    }`}
                                  </th>
                                );
                              }
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          {data.data.map((report, index) => {
                            return (
                              <tr
                                style={{
                                  background:
                                    checkedRows.includes(report.id) &&
                                    "#ffbeb2",
                                }}
                              >
                                {diffArray(
                                  columns,
                                  excludeArrayFromArray(
                                    ["managed in function"],
                                    selectedColumns
                                  )
                                ).map((column) => (
                                  <td
                                    className="py-0 px-1"
                                    style={{
                                      color: `${
                                        report[column] < 0 ? "red" : ""
                                      }`,
                                      fontWeight: `${
                                        report[column] < 0 ? "bold" : ""
                                      }`,
                                      textAlign: "center",
                                    }}
                                  >
                                    {column === "id" && (
                                      <input
                                        checked={checkedRows.includes(
                                          report[column]
                                        )}
                                        onChange={(e) =>
                                          containsItem(report[column])
                                            ? uncheckSingleRow(report[column])
                                            : checkSingleRow(report[column])
                                        }
                                        id={index}
                                        type="checkbox"
                                        className="mr-3"
                                      />
                                    )}

                                    {report[column] ? (
                                      column === "created_time" ||
                                      column === "updated_time" ? (
                                        new Date(
                                          report[column]
                                        ).toLocaleDateString("en-GB")
                                      ) : column === "franchise" ||
                                        column === "branch" ? (
                                        report[column].name
                                      ) : column === "user_of_intrest" ||
                                        column === "delivery_boy" ? (
                                        report[column].first_name
                                      ) : column === ONLINE_PAYMENT_AMOUNT ? (
                                        report[column] === "--" ? (
                                          "--"
                                        ) : (
                                          `₹ ${report[column]}`
                                        )
                                      ) : column === "delivery_charge" ? (
                                        (() => {
                                          const { struck, shown } = deliveryChargeDisplay(report);
                                          return struck ? (
                                            <>
                                              <s className="text-muted">₹ {struck}</s> ₹ {shown}
                                            </>
                                          ) : (
                                            `₹ ${shown}`
                                          );
                                        })()
                                      ) : column === "foodoor_cares" ? (
                                        `₹ ${report.foodoor_cares ?? 0}`
                                      ) : column === "franchise_charge" ||
                                        column === "restaurent_charge" ||
                                        column === DELIVERY_CHARGE_WAIVED ||
                                        column === "incentive" ||
                                        column === "delivery_boy_tip" ||
                                        column === "delivery_boy_earn" ||
                                        column === "amount" ||
                                        column === "wallet_amount_used" ||
                                        column === "total_food_amount" ||
                                        column ===
                                          "franchise_collected_amount" ||
                                        column ===
                                          "commission_amount_on_restaurent" ||
                                        column === "refund_amount" ||
                                        column === "amount_to_restaurant" ||
                                        column === "amount_credited" ||
                                        column === "amount_debited" ? (
                                        `₹ ${report[column]}`
                                      ) : isPercentageColumn(column) ? (
                                        `${report[column]} %`
                                      ) : column === "order" ? (
                                        <a
                                          className="btn btn-outline-primary"
                                          style={{
                                            padding: "2px 10px",
                                            borderRadius: "5px",
                                          }}
                                          href={`/orderID/${report[column]}`}
                                        >
                                          View
                                        </a>
                                      ) : (
                                        report[column]
                                      )
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                ))}
                              </tr>
                            );
                          })}
                        </tbody>
                        <tfoot style={{ position: "sticky", bottom: "0" }}>
                          <tr>
                            {diffArray(
                              columns,
                              excludeArrayFromArray(
                                ["managed in function"],
                                selectedColumns
                              )
                            ).map((column, index) => {
                              return (
                                <th
                                  key={column}
                                  style={{
                                    textAlign: "center",
                                    fontWeight: "bold",
                                    backgroundColor: "#e0e0e0",
                                    color: "#333333",
                                  }}
                                >
                                  {footerCell(data.data, column)}
                                </th>
                              );
                            })}
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <NoDataComponent data="transactions found" />
          )}
        </div>
      ) : (
        <LoadingComponent />
      )}
    </div>
  );
}

function OrderReportNew() {
  return (
    <div>
      <div id="main-wrapper">
        <MainHeader />
        <Header
          name={"Order Reports"}
          subHeading={"All  Orders Transaction Reports"}
        />
        <NavBar />
        <Body />
        <Footer />
      </div>
    </div>
  );
}

export default OrderReportNew;
